import { createSlice } from "@reduxjs/toolkit";

const miscellaneousSlice = createSlice({
  name: "miscellaneous",
  initialState: {
    countryList: [],
    timezoneIdList: [],
    translationLangList: [],
    appLanguageId: 1,
    appSelectedLang: null,
    emailVerifiedAppLanguageId: 0,
    languageList: [],
    securityKeys: {security_iv: '', security_key: ''}
  },
  reducers: {
    setCountryList: (state, action) => {
      state.countryList = action?.payload
    },
    setTimezoneList: (state, action) => {
      state.timezoneIdList = action?.payload
    },
    setTranslationLangList: (state, action) => {
      state.translationLangList = action?.payload
    },
    setAppLanguageId: (state, action) => {
      state.appLanguageId = action?.payload
    },
    setSelectedAppLang: (state, action) => {
      state.appSelectedLang = action?.payload
    },
    setEmailVerifiedAppLangId: (state, action) => {
      state.emailVerifiedAppLanguageId = action?.payload
    },
    setLanguageList: (state, action) => {
      state.languageList = action?.payload
    },
    setSecurityKeys: (state, action) => {
      state.securityKeys = action?.payload
    },
    removeList: (state, action) => {
      if (action?.payload === 'country') {
        state.countryList = []
      } else if (action?.payload === 'timezone') {
        state.timezoneIdList = []
      } else {
        state.translationLangList = []
      }
    },
    clearMisc: (state, action) => {
      state.countryList = []
      state.timezoneIdList = []
      state.securityKeys = {security_iv: '', security_key: ''}
    }
  }
});


// this is for dispatch
export const {
  setCountryList,
  removeList,
  setTimezoneList,
  setTranslationLangList,
  clearMisc,
  setAppLanguageId,
  setSelectedAppLang,
  setEmailVerifiedAppLangId,
  setLanguageList,
  setSecurityKeys
} = miscellaneousSlice.actions;

// this is for configureStore
export default miscellaneousSlice.reducer;